import { render, staticRenderFns } from "./CardExibirPDF.vue?vue&type=template&id=22cc631c&"
import script from "./CardExibirPDF.vue?vue&type=script&lang=js&"
export * from "./CardExibirPDF.vue?vue&type=script&lang=js&"
import style0 from "./CardExibirPDF.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports